var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3333 0C9.23667 0 8.33333 0.903333 8.33333 2V2.9275C4.88167 3.81417 2.33333 6.93667 2.33333 10.6667V16.6667C1.0525 16.6667 0 17.7192 0 19C0 20.2808 1.0525 21.3333 2.33333 21.3333H8V21.6667C8 22.9475 9.0525 24 10.3333 24C11.6142 24 12.6667 22.9475 12.6667 21.6667V21.3333H18.3333C19.6142 21.3333 20.6667 20.2808 20.6667 19C20.6667 17.7192 19.6142 16.6667 18.3333 16.6667V10.6667C18.3333 6.93667 15.785 3.81417 12.3333 2.9275V2C12.3333 0.903333 11.43 0 10.3333 0ZM10.3327 1.33301C10.7135 1.33301 10.9993 1.61884 10.9993 1.99967V2.69801C10.781 2.67967 10.556 2.66634 10.3327 2.66634C10.1093 2.66634 9.88435 2.67967 9.66602 2.69801V1.99967C9.66602 1.61884 9.95185 1.33301 10.3327 1.33301ZM17.0013 10.6667C17.0013 6.96167 14.0396 4 10.3346 4C6.62964 4 3.66797 6.96167 3.66797 10.6667V16.6667H17.0013V10.6667ZM2.33203 18H18.332C18.8979 18 19.332 18.4342 19.332 19C19.332 19.5658 18.8979 20 18.332 20H2.33203C1.7662 20 1.33203 19.5658 1.33203 19C1.33203 18.4342 1.7662 18 2.33203 18ZM11.332 21.333H9.33203V21.6663C9.33203 22.2322 9.7662 22.6663 10.332 22.6663C10.8979 22.6663 11.332 22.2322 11.332 21.6663V21.333Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSide);
export default __webpack_public_path__ + "static/media/notification_side.6f709bf719b548676ee965f846c57241.svg";
export { ForwardRef as ReactComponent };